export default "__VITE_ASSET__Cmtnpyb3__"